import axios from 'axios';
import { toast } from 'react-toastify';
// import { useIntl } from 'react-intl';

// export const useCustomIntl = () =>
// {
// 	const intl = useIntl();

// 	return intl;
// };

async function callApi(data, signal)
{
	try
	{
		const token = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'token');

		if (token)
		{
			const config = {
				method        : 'post',
				maxBodyLength : Infinity,
				url           : import.meta.env.VITE_S3_AUTH_MYFILES_API,
				headers       : {
					'Authorization' : `Bearer ${token}`,
					'Content-Type'  : 'application/json'
				},
				data : data
			};

			if (signal)
			{
				config.signal = signal;
			}

			const response = await axios.request(config);

			console.log('meeting data===', JSON.stringify(response.data));

			return response.data;
		}
		else
		{
			toast.dismiss();
			toast.error('Controller pairing failed. Please pair it again!');
			// eslint-disable-next-line react-hooks/rules-of-hooks
			// toast.error(useCustomIntl().formatMessage({ id: 'Controller_pairing_failed', defaultMessage: 'Controller pairing failed. Please pair it again!' }));
		}
	}
	catch (error)
	{
		console.log('Error occurred while fetching data:', error);
		throw error;
	}
}

export default callApi;
